import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FilledInput
} from '@material-ui/core';
import { useTimeZones } from '~/modules/resource-management/resourceUserDetails/hooks';

const label = <FormattedMessage id="resourceBasicInfoCard.timeZone" />;
const input = <FilledInput />;

const renderSelectedTimeZoneValue = displayText => () => displayText;

export const UserTimeZoneDropdown = ({ onValueChange, selectedTimeZone }) => {
  const { timeZones, loading } = useTimeZones();
  const handleTimeZoneChange = useCallback(
    e => {
      onValueChange(timeZones.find(tz => tz.id === e.target.value));
    },
    [onValueChange, timeZones]
  );

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedTimeZone?.id}
        onChange={handleTimeZoneChange}
        input={input}
        disabled={loading}
        renderValue={renderSelectedTimeZoneValue(selectedTimeZone?.displayText)}
      >
        {(timeZones || []).map(tz => (
          <MenuItem key={tz.id} value={tz.id}>
            {tz.displayText}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

UserTimeZoneDropdown.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  selectedTimeZone: PropTypes.shape({
    id: PropTypes.string,
    displayText: PropTypes.string
  })
};
